import type { PageHeaderBreadcrumb } from '@verantos-dev/shared-components';

import { useProjectRootBreadcrumbs } from './useProjectRootBreadcrumbs';

export interface UseConceptGroupBreadcrumbsResult {
  breadcrumbs: PageHeaderBreadcrumb[];
}

/**
 * Per-page breadcrumbs for the project concept-group detail view (OR-6123 F8).
 *
 * `Projects / <project> / <concept group>` — the trailing crumb is the
 * concept-group name (passed in by the page, which already queries it). Split
 * out of the old monolithic `useProjectBreadcrumbs`.
 *
 * TODO: cleanup with research_assistant_gen_3 ff
 */
export const useConceptGroupBreadcrumbs = ({
  conceptGroupName,
  isLoading,
}: {
  conceptGroupName: string | undefined;
  isLoading: boolean;
}): UseConceptGroupBreadcrumbsResult => {
  const { rootCrumbs } = useProjectRootBreadcrumbs();

  return {
    breadcrumbs: [
      ...rootCrumbs,
      {
        label: conceptGroupName ?? '',
        isLoading: isLoading && !conceptGroupName,
      },
    ],
  };
};
